import React from 'react';
import { Button, Modal } from 'antd';

interface DownloadDataModalProps {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function DownloadDataModal({
  isVisible,
  setIsVisible,
}: DownloadDataModalProps) {
  return (
    <Modal
      closable={false}
      keyboard={false}
      open={isVisible}
      title={'Successfully created request for spectra files'}
      onOk={() => {
        setIsVisible(false);
      }}
      footer={[
        <Button
          key='ok'
          onClick={() => {
            setIsVisible(false);
          }}
        >
          {' '}
          Ok{' '}
        </Button>,
      ]}
    >
      {
        'An email with a link to download the data will be sent to you within 15 minutes.'
      }
    </Modal>
  );
}
